import vkAlert from './vkAlert.vue'

const VkAlert = {}

VkAlert.install = function (Vue, options) {
    const _vkAlertInstance = Vue.extend(vkAlert)
    let currentMsg
    const init = (options, type) => {
        currentMsg = null
        initInstance()

        if (typeof options === 'string') {
            currentMsg.content = options
        } else if (Object.prototype.toString.call(options) === '[object Object]') {
            Object.assign(currentMsg, options)
        } else {
            console.warn('Expect get a String or Object, but it is not! it will be ignored！')
        }
        // 防止传参改动
        currentMsg.type = type
    }
    const initInstance = () => {
        currentMsg = new _vkAlertInstance()
        let msgBoxEl = currentMsg.$mount().$el
        document.body.appendChild(msgBoxEl)
    }

    // 简单的 alert 提示信息， 用callback实现
    Vue.prototype.$alert = function (options, callback) {
        init(options, 'alert')
        currentMsg.showAlertComponent(callback)
    }

    //  confirm确认框信息 ， 用promission实现
    Vue.prototype.$confirm = function (options) {
        init(options, 'confirm')
        return currentMsg.showConfirmComponent().then(val => {
                currentMsg = null
                return Promise.resolve(val)
            })
            .catch(err => {
                currentMsg = null;
                return Promise.reject(err)
            })
    }
}

export default VkAlert